import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSnackbar } from '../context/SnackbarContext';
import { pushApi } from '../api/push';
import { isNative } from '../platform/isNative';
import { AppPreferences } from '../platform/preferences';
import { clearDeliveredNotifications } from '../platform/push';

const NATIVE_PUSH_CLEANUP_MS = 2000;

/**
 * Logout prodotto: su native esegue cleanup push con timeout (senza FCM il plugin
 * può appendere e bloccare la UI), poi invalida la sessione e va a /login.
 */
export function useAppLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  return useCallback(async () => {
    try {
      if (isNative()) {
        await Promise.race([
          (async () => {
            try {
              const deviceId = await AppPreferences.get('cantir.push.deviceId');
              if (deviceId) {
                await pushApi.unregister(deviceId);
              }
              await clearDeliveredNotifications();
            } catch {
              // Push cleanup is best-effort
            }
          })(),
          new Promise<void>((resolve) => {
            setTimeout(resolve, NATIVE_PUSH_CLEANUP_MS);
          }),
        ]);
      }
      await logout();
      navigate('/login', { replace: true });
    } catch {
      showMessage('Errore durante il logout.', 'error');
    }
  }, [logout, navigate, showMessage]);
}
